(() => {
  'use strict';

  const Q = {
    card: '[data-scv2-card]',
    track: '[data-scv2-track]',
    slide: '[data-scv2-slide]',
    prev: '[data-scv2-prev]',
    next: '[data-scv2-next]',
    size: '[data-scv2-size]',
    add: '[data-scv2-add]',
    defaultVariant: '[data-scv2-default-variant]',
    message: '[data-scv2-message]',
    addText: '[data-scv2-add-text]',
    addLoading: '[data-scv2-add-loading]',
    imageLink: '[data-scv2-image-link]'
  };

  const stop = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const cardOf = (element) => element?.closest(Q.card);

  function render(card, requestedIndex) {
    const track = card?.querySelector(Q.track);
    const slides = [...(card?.querySelectorAll(Q.slide) || [])];

    if (!track || slides.length < 2) return;

    const index = (requestedIndex + slides.length) % slides.length;
    card.dataset.currentIndex = String(index);
    track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;

    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
  }

  function setMessage(node, text, type = '') {
    if (!node) return;
    node.textContent = text;
    node.classList.toggle('is-error', type === 'error');
    node.classList.toggle('is-success', type === 'success');
  }

  function cartSections() {
    const ids = [];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    return ids.join(',');
  }

  function updateSections(sections) {
    Object.entries(sections || {}).forEach(([id, html]) => {
      if (!html) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');

      if (id === 'cart-drawer') {
        const current = document.querySelector('cart-drawer');
        const replacement = parsed.querySelector('cart-drawer');
        if (current && replacement) current.innerHTML = replacement.innerHTML;
      }

      if (id === 'cart-icon-bubble') {
        const current = document.getElementById('cart-icon-bubble');
        const replacement = parsed.getElementById('cart-icon-bubble');
        if (current && replacement) current.innerHTML = replacement.innerHTML;
      }
    });
  }

  async function addToCart(card, button) {
    const variantId =
      card.dataset.selectedVariantId ||
      card.querySelector(Q.defaultVariant)?.value;

    const message = card.querySelector(Q.message);
    const text = card.querySelector(Q.addText);
    const loadingText = card.querySelector(Q.addLoading);

    if (!variantId) {
      setMessage(message, 'Selecciona una talla.', 'error');
      return;
    }

    button.disabled = true;
    if (text) text.hidden = true;
    if (loadingText) loadingText.hidden = false;
    setMessage(message, '');

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: cartSections(),
          sections_url: window.location.pathname
        })
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description ||
          result.message ||
          'No fue posible agregar el producto.'
        );
      }

      updateSections(result.sections);
      setMessage(message, 'Producto agregado. Puedes seguir comprando.', 'success');
      window.setTimeout(() => setMessage(message, ''), 2500);
    } catch (error) {
      setMessage(
        message,
        error.message || 'No fue posible agregar el producto.',
        'error'
      );
    } finally {
      if (text) text.hidden = false;
      if (loadingText) loadingText.hidden = true;
      button.disabled = false;
    }
  }

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;

    const prev = event.target.closest(Q.prev);
    const next = event.target.closest(Q.next);
    const size = event.target.closest(Q.size);
    const add = event.target.closest(Q.add);
    const imageLink = event.target.closest(Q.imageLink);

    if (prev || next) {
      stop(event);
      const card = cardOf(prev || next);
      if (!card) return;
      render(card, Number(card.dataset.currentIndex || 0) + (next ? 1 : -1));
      return;
    }

    if (size) {
      stop(event);
      const card = cardOf(size);
      if (!card) return;

      card.querySelectorAll(Q.size).forEach((button) => {
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed', 'false');
      });

      size.classList.add('is-selected');
      size.setAttribute('aria-pressed', 'true');
      card.dataset.selectedVariantId = size.dataset.variantId || '';

      const addButton = card.querySelector(Q.add);
      if (addButton) addButton.disabled = !card.dataset.selectedVariantId;
      setMessage(card.querySelector(Q.message), '');
      return;
    }

    if (add) {
      stop(event);
      const card = cardOf(add);
      if (!card || add.disabled) return;
      await addToCart(card, add);
      return;
    }

    if (imageLink) {
      const card = cardOf(imageLink);
      if (card?.dataset.preventNextImageClick === 'true') {
        event.preventDefault();
        card.dataset.preventNextImageClick = 'false';
      }
    }
  }, true);

  let touchCard = null;
  let touchStartX = 0;

  document.addEventListener('touchstart', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('button,input,select,textarea,label')) return;

    touchCard = event.target.closest(Q.card);
    touchStartX = event.changedTouches[0]?.clientX || 0;
  }, { passive: true });

  document.addEventListener('touchend', (event) => {
    if (!touchCard) return;

    const endX = event.changedTouches[0]?.clientX || touchStartX;
    const distance = endX - touchStartX;

    if (Math.abs(distance) >= 45) {
      touchCard.dataset.preventNextImageClick = 'true';
      render(
        touchCard,
        Number(touchCard.dataset.currentIndex || 0) + (distance < 0 ? 1 : -1)
      );
    }

    touchCard = null;
  }, { passive: true });

    let observer = null;
  let loadingMore = false;

  /*
   * Guarda las URLs que ya fueron cargadas para evitar
   * que una misma página se agregue dos veces.
   */
  const loadedPageUrls = new Set();

  function normalizePageUrl(url) {
    try {
      const parsedUrl = new URL(url, window.location.origin);

      /*
       * Ordenamos los parámetros para que dos URLs equivalentes
       * sean identificadas como la misma página.
       */
      parsedUrl.hash = '';

      return `${parsedUrl.pathname}${parsedUrl.search}`;
    } catch (error) {
      return String(url || '');
    }
  }

  function getPageNumber(url) {
    try {
      return Number(
        new URL(url, window.location.origin).searchParams.get('page') || 1
      );
    } catch (error) {
      return 1;
    }
  }

  function nextLink(pagination) {
    if (!pagination) return null;

    /*
     * Shopify normalmente incluye rel="next".
     * Esta será siempre la opción prioritaria.
     */
    const directNext = pagination.querySelector(
      'a[rel="next"], ' +
      'a.pagination__item--next, ' +
      'a[aria-label*="Next" i], ' +
      'a[aria-label*="Siguiente" i]'
    );

    if (directNext?.href) {
      const normalizedUrl = normalizePageUrl(directNext.href);

      if (!loadedPageUrls.has(normalizedUrl)) {
        return directNext;
      }
    }

    /*
     * Respaldo para temas cuya paginación no tiene rel="next".
     */
    const availableLinks = [...pagination.querySelectorAll('a[href]')]
      .filter((link) => {
        const normalizedUrl = normalizePageUrl(link.href);

        return (
          getPageNumber(link.href) > 1 &&
          !loadedPageUrls.has(normalizedUrl)
        );
      })
      .sort((firstLink, secondLink) => {
        return (
          getPageNumber(firstLink.href) -
          getPageNumber(secondLink.href)
        );
      });

    return availableLinks[0] || null;
  }

  function productIdentity(element) {
    /*
     * Intenta identificar cada producto mediante su URL.
     * Sirve como segunda protección contra productos duplicados.
     */
    const productLink = element.querySelector(
      'a[href*="/products/"]'
    );

    if (!productLink?.href) return '';

    try {
      const url = new URL(productLink.href, window.location.origin);
      return url.pathname;
    } catch (error) {
      return productLink.getAttribute('href') || '';
    }
  }

  function existingProductIds(grid) {
    const ids = new Set();

    [...grid.children].forEach((item) => {
      const identity = productIdentity(item);

      if (identity) {
        ids.add(identity);
      }
    });

    return ids;
  }

  function initInfiniteScroll() {
    const grid = document.getElementById('product-grid');
    const pagination = document.querySelector('.pagination-wrapper');

    if (!grid || !pagination) return;

    /*
     * Evita inicializar dos observadores en la misma sección.
     */
    if (pagination.dataset.scv2Infinite === 'true') return;

    pagination.dataset.scv2Infinite = 'true';

    /*
     * Registramos la página actual para que nunca vuelva
     * a insertarse accidentalmente.
     */
    loadedPageUrls.add(normalizePageUrl(window.location.href));

    const sentinel = document.createElement('div');
    sentinel.className = 'santorini-infinite-loader';
    sentinel.setAttribute('aria-live', 'polite');
    sentinel.textContent = 'Cargando más productos…';

    pagination.parentNode.insertBefore(sentinel, pagination);
    pagination.hidden = true;

    if (observer) {
      observer.disconnect();
    }

    observer = new IntersectionObserver(
      async ([entry]) => {
        if (!entry?.isIntersecting || loadingMore) return;

        const link = nextLink(pagination);

        if (!link?.href) {
          observer.disconnect();
          sentinel.className = 'santorini-infinite-end';
          sentinel.textContent = 'Has visto todos los productos';
          return;
        }

        const requestedUrl = normalizePageUrl(link.href);

        /*
         * Evita una solicitud duplicada mientras la página
         * se encuentra cargando.
         */
        if (loadedPageUrls.has(requestedUrl)) {
          return;
        }

        loadingMore = true;
        loadedPageUrls.add(requestedUrl);

        sentinel.className = 'santorini-infinite-loader';
        sentinel.textContent = 'Cargando más productos…';

        try {
          const response = await fetch(link.href, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'text/html'
            },
            credentials: 'same-origin'
          });

          if (!response.ok) {
            throw new Error(
              `No fue posible cargar la página siguiente (${response.status}).`
            );
          }

          const html = await response.text();

          const parsed = new DOMParser().parseFromString(
            html,
            'text/html'
          );

          const newGrid = parsed.getElementById('product-grid');
          const newPagination = parsed.querySelector(
            '.pagination-wrapper'
          );

          if (!newGrid) {
            throw new Error(
              'No se encontró #product-grid en la página siguiente.'
            );
          }

          const currentProductIds = existingProductIds(grid);

          const newItems = [...newGrid.children].filter((item) => {
            const identity = productIdentity(item);

            /*
             * Si no podemos identificar el producto, se conserva.
             * Si ya existe, se descarta.
             */
            if (!identity) return true;
            if (currentProductIds.has(identity)) return false;

            currentProductIds.add(identity);
            return true;
          });

          if (newItems.length) {
            const fragment = document.createDocumentFragment();

            newItems.forEach((item) => {
              fragment.appendChild(item);
            });

            grid.appendChild(fragment);
          }

          /*
           * Actualizamos exclusivamente el contenido interno
           * de la paginación para obtener el siguiente enlace.
           */
          if (newPagination) {
            pagination.innerHTML = newPagination.innerHTML;
          } else {
            pagination.innerHTML = '';
          }

          /*
           * Importante:
           * No se utiliza history.replaceState().
           * La URL conserva la colección original.
           */

          if (!nextLink(pagination)) {
            observer.disconnect();
            sentinel.className = 'santorini-infinite-end';
            sentinel.textContent = 'Has visto todos los productos';
          }
        } catch (error) {
          console.error(
            'SANTORINI V2 - scroll infinito:',
            error
          );

          /*
           * Permitimos volver a intentar esta URL si ocurrió un error.
           */
          loadedPageUrls.delete(requestedUrl);

          observer.disconnect();
          pagination.hidden = false;
          sentinel.className = 'santorini-infinite-error';
          sentinel.textContent =
            'No fue posible cargar más productos. Usa la paginación.';
        } finally {
          loadingMore = false;
        }
      },
      {
        root: null,
        rootMargin: '700px 0px',
        threshold: 0
      }
    );

    observer.observe(sentinel);
  }

  /*
   * Al volver mediante el botón Atrás, algunos navegadores recuperan
   * la página desde memoria. pageshow funciona mejor que depender
   * únicamente de DOMContentLoaded.
   */
  function startInfiniteScroll() {
    window.requestAnimationFrame(() => {
      initInfiniteScroll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startInfiniteScroll,
      { once: true }
    );
  } else {
    startInfiniteScroll();
  }

  window.addEventListener('pageshow', (event) => {
    /*
     * Si la página fue restaurada desde el caché del navegador,
     * no reiniciamos el listado si ya existe un observador activo.
     */
    if (event.persisted) {
      const pagination = document.querySelector(
        '.pagination-wrapper'
      );

      if (
        pagination &&
        pagination.dataset.scv2Infinite !== 'true'
      ) {
        startInfiniteScroll();
      }
    }
  });

  document.addEventListener(
    'shopify:section:load',
    startInfiniteScroll
  );
  })();
